import { render, staticRenderFns } from "./calendarDayNewItem.vue?vue&type=template&id=45638a06&scoped=true&"
import script from "./calendarDayNewItem.vue?vue&type=script&lang=js&"
export * from "./calendarDayNewItem.vue?vue&type=script&lang=js&"
import style0 from "./calendarDayNewItem.vue?vue&type=style&index=0&id=45638a06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45638a06",
  null
  
)

export default component.exports